import clsx from 'clsx';

interface TeamInfoSponsorsListSkeletonProps {
	className?: string;
}

export const TeamInfoSponsorsListSkeleton = ({ className }: TeamInfoSponsorsListSkeletonProps) => {
	return (
		<div className={clsx('hidden md:block mt-6 px-6', className)}>
			<h3 className="text-lg font-semibold mb-1">Player Sponsors</h3>
			<div className="flex gap-4 overflow-x-auto pb-2 bg-gray-200 rounded-lg p-2">
				{Array.from({ length: 6 }).map((_, index) => (
					<div
						key={`sponsors_list_${index}`}
						className="flex items-center justify-center bg-gray-300 rounded-md border w-28 h-20 flex-shrink-0 shadow-sm animate-pulse"
					>
						<div className="w-16 h-12 bg-gray-200 rounded" />
					</div>
				))}
			</div>
		</div>
	);
};
